<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <ContainerLoader v-if="isLoading || isSaving" />

        <div class="page acertos">
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('despesas') }}
                    </h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('despesas') }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{ $t('despesa-automatica') }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button
                        v-if="permissao.create"
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
            <div class="vertical-flow">
                <p class="mt-2 mb-2">
                    {{ $t('info-trabalhar-com-despesa-km-automatica') }}
                </p>
                <div v-for="(r, i) in minimumrequirements" :key="i">
                    <div
                        v-if="!r.metTheRequirements"
                        class="notification is-danger is-light mb-2 p-2"
                    >
                        <strong>{{ $t('falta-requisitos') }}:</strong>
                        {{ $t(r.message) }}
                        <router-link :to="{ name: r.name_route }">
                            {{ $t('clique-aqui') }}</router-link
                        >
                    </div>
                </div>
                <group-selector
                    v-if="requirementsMet"
                    :toSelect="collaborators"
                    v-model="selectedCollaborators"
                    fieldName="nome"
                    groupOneLabel="usuarios-que-nao-trabalha-com-despesa-auto"
                    groupTwoLabel="usuarios-que-trabalha-com-despesa-auto"
                    @unselectedItems="getUnselectedCollaborators"
                    :useValidation="true"
                    attrValidation="latitude"
                    validationLegend="usuario-com-coordenada-invalida"
                    :disable="!permissao.create"
                />
            </div>
        </div>
        <!-- end .page.mb-0 -->
    </div>
    <!-- end #main -->
</template>

<script>
import ColaboradorService from '@/services/ColaboradorService';
import DespesaAutomaticaService from '@/services/despesas/DespesaAutomaticaService';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import GroupSelector from '@/components/shared/GroupSelector';

export default {
    components: {
        ContainerLoader,
        GroupSelector,
    },
    data() {
        return {
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            service: new DespesaAutomaticaService(this.$http, this.$router),
            msgs: [],
            isLoading: false,
            isSaving: false,
            minimumrequirements: [
                {
                    requirements: 'key-gmaps',
                    message: '',
                    metTheRequirements: true,
                    name_route: 'configuracao-mapas',
                },
                {
                    requirements: 'valor-km',
                    message: '',
                    metTheRequirements: true,
                    name_route: 'des-valor-km',
                },
                {
                    requirements: 'motivos-despesas',
                    message: '',
                    metTheRequirements: true,
                    name_route: 'des-motivo-despesa',
                },
            ],
            requirementsMet: true,
            collaborators: [],
            selectedCollaborators: [],
            unselectedCollaborators: [],
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'despesas',
            'cadastros',
            'des-despesa-automatica'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesa-automatica' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        loadVendedores() {
            this.service
                .buscaTodosUsuarios()
                .then((r) => {
                    this.collaborators = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por vendedores. Termo: [${q}].`, e);
                    this.colaboradores = [];
                });
        },
        mapToSave() {
            //Monta objeto conforme necessário para API
            let temp = [
                {
                    insert: [],
                },
                {
                    remove: [],
                },
            ];
            this.selectedCollaborators.map((sc) => {
                temp[0].insert.push({ idusuario: sc.id });
            });
            this.unselectedCollaborators.map((sc) => {
                temp[1].remove.push({ idusuario: sc.id });
            });
            return temp;
        },
        getUnselectedCollaborators(payload) {
            this.unselectedCollaborators = [...payload];
        },
        findAllUserWorkAutoKm() {
            this.service
                .findAllUserWorkAutoKm()
                .then((r) => {
                    if (r.content != null) {
                        this.selectedCollaborators = r.content;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao salvar configuração.`, e);
                });
        },
        validateRequirements() {
            //METODO QUE RECEBE TODAS AS INFORMAÇÕES SOBRE OS REQUISITOS.
            //REQUISITOS DEFINIDO FIXADAMENTE NO ARRAY "minimumrequirements"
            this.service.hasGmapKey().then((r) => {
                if (!r.content) {
                    this.minimumrequirements[0].metTheRequirements = r.content;
                    this.minimumrequirements[0].message = r.message;
                    this.requirementsMet = r.content;
                } else {
                    this.minimumrequirements[0].metTheRequirements = r.content;
                }
            });
            this.service.possuiValorKmAtivo().then((r) => {
                if (!r.content) {
                    this.minimumrequirements[1].metTheRequirements = r.content;
                    this.minimumrequirements[1].message = r.message;
                    this.requirementsMet = r.content;
                } else {
                    this.minimumrequirements[0].metTheRequirements = r.content;
                }
            });
            this.service.possuiDespesaAutomatica().then((r) => {
                if (!r.content) {
                    this.minimumrequirements[2].metTheRequirements = r.content;
                    this.minimumrequirements[2].message = r.message;
                    this.requirementsMet = r.content;
                } else {
                    this.minimumrequirements[0].metTheRequirements = r.content;
                }
            });
        },
        save() {
            this.isSaving = true;
            this.service
                .save(this.mapToSave())
                .then((r) => {
                    if (r.status == 200) {
                        this.showMessage('success', 'config-atualizada-com-sucesso');
                    } else {
                        this.showMessage('error', 'error-ao-atualizar-config');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao salvar configuração.`, e);
                    this.showMessage('error', 'error-ao-atualizar-config');
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        carregarDados() {
            this.loadVendedores();
            this.findAllUserWorkAutoKm();
            this.validateRequirements();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    height: auto;
    min-height: 100%;

    .page {
        position: relative;
        height: 100%;
    }
    .vertical-flow {
        padding: 20px;
        background-color: $sovis-white;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }
}
</style>
